import ClipboardJS from 'clipboard/dist/clipboard.min.js'

// ВАЖНО! Кривая сборка в dist

export const create = (selector: string) => new ClipboardJS(selector)
